/*
 * Copyright (c) 2018 - Indigen Solutions
 * Authors:
 *   - Bichoy Messiha <bm@indigen.com>
 * NOTICE: All information contained here in is, and remains
 * the property of Adobe Systems Incorporated and its suppliers,
 * if any.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Indigen Solutions.
 */
import { isType, setNotification } from "../actions";
import { NotificationItem } from "../../types/NotificationItem";

const initialState: NotificationItem = null;

export default function notificationReducer(state: NotificationItem = initialState, action) {
    if (isType(action, setNotification)) {
        return action.payload;
    }
    return state;
}


// WEBPACK FOOTER //
// ./src/store/reducers/notification.reducer.ts